<div class="segmented-control__container">
    <label class="segmented-control__label">
        {{ data.label }}
    </label>
    <div class="segmented-control__options-wrapper">
        <div class="segmented-control__option-wrapper" [ngClass]="{'segmented-control__option-wrapper--active': option.active}" *ngFor="let option of data.options" (click)="selectOption(option)">
            <span>{{ option.label }}</span>
        </div>
    </div>
</div>